import Request from './request'

const Reports  = {
  getReports(params, callback) {
    Request.get('reports', params).then(callback).catch(this.bad_answer)
  },
}

export default Reports
